import {Injectable, Injector} from '@angular/core';
import {Router} from '@angular/router';
// import { CommonService } from '../common/common.service';
import { CommonService } from '@modweb5/sharedServices/commonService/common.service';

import {environment} from '@modweb5/environments/frontends/environment';

@Injectable({
	providedIn: 'root'
})
export class NavigateService {

	private router: Router;
	private wasLastQueryParams = false;
	private lastRouteParams;
	private lastQueryParams;

	constructor(
		/**
		 * To avoid circular dependency between <APP_INITIALIZER> and <Router> injection,
		 * it's necessary to inject <Router> explicitly after <APP_INITIALIZER> is processed.
		 * That's why the method <getRouter> is called in the moment when the first routing is done.
		 */
			private injector: Injector,
			private commonService: CommonService
	) { 
	}

	private getRouter(): Router {
		return this.injector.get(Router);
	}

	// ----------------------------------------------------------------------------------------------
	navigate = (aRouteParams: string | null, aQueryParams: any): void => {

		if (!this.router) {
			this.router = this.getRouter();
		}
		if ((typeof aQueryParams !== typeof undefined) && (aQueryParams !== '')) {
			this.lastRouteParams = aRouteParams;
			this.lastQueryParams = aQueryParams;
			this.wasLastQueryParams = true;
			this.router.navigate([aRouteParams], aQueryParams);
		} else {
			this.wasLastQueryParams = false;
			this.lastRouteParams = aRouteParams;
			this.router.navigate([aRouteParams]);
		}
	}


}
